import { DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteGreen, ColorPaletteOrange, ColorPaletteRed } from '../../components/theme.palette';

export const CSS = {
	container: 'c-ValidationNotification',
	section: 'c-ValidationNotification__section',
	sectionTitle: 'c-ValidationNotification__sectionTitle',
	content: 'c-ValidationNotification__content',
	modal: 'c-ValidationNotification__modal',
	message: 'c-ValidationNotification__message',
	categorySection: 'c-ValidationNotification__categorySection',
	categorySectionError: 'c-ValidationNotification__categorySection--error',
	categorySectionWarning: 'c-ValidationNotification__categorySection--warning',
	categorySectionInfo: 'c-ValidationNotification__categorySection--info',
	categoryHeading: 'c-ValidationNotification__categoryHeading',
};

export const Style = {
	[CSS.container]: {
		color: DefaultTheme.font.color.primary,
	},
	[CSS.section]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.sectionTitle]: {
		'font-weight': DefaultTheme.font.weight.bold,
	},
	[CSS.content]: {
		'list-style': 'none',
		margin: 0,
	},
	[CSS.modal]: {
		'min-width': '650px',
	},
	[CSS.categorySection]: {
		'margin-bottom': DefaultTheme.space(3),
		padding: DefaultTheme.space(2),
		'border-left': '4px solid transparent',
		'border-radius': '2px',
	},
	[CSS.categorySectionError]: {
		'border-left-color': rgba(ColorPaletteRed.A700),
		'background-color': rgba(ColorPaletteRed.A700, 0.05),
	},
	[CSS.categorySectionWarning]: {
		'border-left-color': rgba(ColorPaletteOrange.C700),
		'background-color': rgba(ColorPaletteOrange.C700, 0.05),
	},
	[CSS.categorySectionInfo]: {
		'border-left-color': rgba(ColorPaletteGreen.A300),
		'background-color': rgba(ColorPaletteGreen.A300, 0.05),
	},
	[CSS.categoryHeading]: {
		'font-weight': DefaultTheme.font.weight.bold,
		'font-size': '16px',
		'margin-bottom': DefaultTheme.space(2),
	},
};
